const DAY_MS = 86_400_000;

export function todayInJapan(now = new Date()): string {
  const parts = new Intl.DateTimeFormat("en-US", {
    timeZone: "Asia/Tokyo",
    year: "numeric",
    month: "2-digit",
    day: "2-digit",
  }).formatToParts(now);
  const values = Object.fromEntries(parts.map((part) => [part.type, part.value]));
  return `${values.year}-${values.month}-${values.day}`;
}

export function toUtcDate(isoDate: string): Date {
  return new Date(`${isoDate}T00:00:00Z`);
}

export function fromUtcDate(date: Date): string {
  return date.toISOString().slice(0, 10);
}

export function addDays(isoDate: string, amount: number): string {
  const date = toUtcDate(isoDate);
  date.setUTCDate(date.getUTCDate() + amount);
  return fromUtcDate(date);
}

export function daysBetween(from: string, to: string): number {
  return Math.floor((toUtcDate(to).valueOf() - toUtcDate(from).valueOf()) / DAY_MS);
}

export function monthKey(isoDate: string): string {
  return isoDate.slice(0, 7);
}

export function shiftMonth(month: string, amount: number): string {
  const [year, monthNumber] = month.split("-").map(Number);
  const date = new Date(Date.UTC(year, monthNumber - 1 + amount, 1));
  return fromUtcDate(date).slice(0, 7);
}

export function calendarRange(month: string): { from: string; to: string; days: string[] } {
  const first = `${month}-01`;
  const start = addDays(first, -toUtcDate(first).getUTCDay());
  const days = Array.from({ length: 42 }, (_, index) => addDays(start, index));
  return { from: days[0], to: days[41], days };
}

export function formatDateLong(isoDate: string): string {
  return new Intl.DateTimeFormat("ja-JP", {
    timeZone: "UTC",
    year: "numeric",
    month: "long",
    day: "numeric",
    weekday: "short",
  }).format(toUtcDate(isoDate));
}

export function formatMonth(month: string): string {
  return new Intl.DateTimeFormat("ja-JP", {
    timeZone: "UTC",
    year: "numeric",
    month: "long",
  }).format(toUtcDate(`${month}-01`));
}

export function formatTime(isoDateTime: string): string {
  return new Intl.DateTimeFormat("ja-JP", {
    timeZone: "Asia/Tokyo",
    hour: "2-digit",
    minute: "2-digit",
  }).format(new Date(isoDateTime));
}
